/* eslint-disable */
import {
  Checkbox,
  Flex,
  Popover,
  Radio,
  Space,
  Button,
  Modal,
  Form,
  Select,
  message,
  Input,
  Tooltip
} from "antd";
import React, { useEffect, useRef, useState } from "react";
import "./index.css";
import {
  CaretDownOutlined,
  OneToOneOutlined,
  SyncOutlined,
  VerticalAlignBottomOutlined,
  CheckOutlined,
  CloseOutlined,
  MailOutlined,
} from "@ant-design/icons";
import api from "@/utils/api";
import http from "@/utils/http";
import { CustomTable } from "@/hocComponents";
import { checkApproveRouteDict } from "@/utils/dict";
import commonFn from "@/utils/commonFn";
export default function ApprovalRequest() {
  // 默认选中的值
  const [selectedItems, setSelectedItems] = useState([]);
  const [options, setOptions] = useState([]);
  const [moduleList, setModuleList] = useState([]);
  const [totalDetail, setTotalDetail] = useState(0);
  const [approvedOrRejected, setApprovedOrRejected] = useState("Approved");
  const [openApproval, setOpenApproval] = useState(false);
  const [btnLoading, setBtnLoading] = useState(false);
  const [approvalForm] = Form.useForm();
  const [selectedList, setSelectedList] = useState([]);
  const [ids, setIds] = useState([]);
  // 处理选项变化
  const handleChange = (checkedValues) => {
    setSelectedItems(checkedValues);
    setColumns(
      initColumns.map((item) => ({
        ...item,
        hidden: !checkedValues.includes(item.dataIndex),
      }))
    );
  };
  // Popover 的内容
  const content = (
    <div style={{ display: "flex", flexDirection: "column", gap: "8px" }}>
      <Checkbox.Group
        options={options}
        value={selectedItems}
        className="checkBox"
        onChange={handleChange}
      >
        {/* 使用 Space 的 direction="vertical" 来让复选框垂直排列 */}
        <Space direction="vertical">
          {options.map((option) => (
            <Checkbox key={option.value} value={option.value}>
              {option.label}
            </Checkbox>
          ))}
        </Space>
      </Checkbox.Group>
    </div>
  );
  const content2 = <a>Export to CSV</a>;

  // table
  const initTableHead = {
    role: null,
    module: null,
    firstName: null,
    dateTimeRequest: null,
  };
  const [tableHead, setTableHead] = useState(initTableHead);

  const tableFilterFn = (event, key, type = "Input") => {
    commonFn.tableFilterFn({ event, key, type, setTableHead, getTableListFn, pageSize: 100 });
  };

  const initColumns = [
    {
      title: "Name",
      dataIndex: "firstName",
      titleType: "Input",
      width: 110,
      isSorter: true,
      sortterMultiple: 2,
      onChange: (e) => tableFilterFn(e, "firstName"),
    },
    {
      title: "Role",
      dataIndex: "role",
      titleType: "Input",
      width: 100,
      isSorter: true,
      sortterMultiple: 3,
      onChange: (e) => tableFilterFn(e, "role"),
    },
    {
      title: "Module",
      dataIndex: "moduleType",
      titleType: "Select",
      width: 100,
      isSorter: true,
      sortterMultiple: 3,
      selectOptions: moduleList,
      onChange: (value) => tableFilterFn(value, "module", "Select"),
    },
    {
      title: "Transactions",
      dataIndex: "transactions",
      titleType: "",
      width: 100,
      render: (text, record) => {
        return (
          <Tooltip title={record?.storeName}>
            <span
              style={{
                textDecoration: "underline",
              }}
              className="CA-AS-AmountStyle"
              onClick={() => handleDetailClick(record)}
            >
              {text}
            </span>
          </Tooltip>
        );
      },
    },
    {
      title: "Total Amount",
      dataIndex: "amount",
      titleType: "",
      width: 100,
      isAmountFlag: true,
    },
    {
      title: "Level2 Approval",
      dataIndex: "lastPayPeriod",
      titleType: "",
      width: 100,
    },
    {
      title: "Date &Time Requests",
      dataIndex: "dateTimeRequest",
      titleType: "DatePicker",
      width: 80,
      format: "MM/DD/YYYY HH:mm",
      onChange: (e) => tableFilterFn(e, "dateTimeRequest", "DatePicker"),
    },
  ];

  const [columns, setColumns] = useState([]);
  const [refreshKey, setRefreshKey] = useState(0);
  const [tableList, setTableList] = useState([]);
  const [tableLoading, setTableLoading] = useState(false);
  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 100,
    total: 0,
  });
  // 获取列表数据
  const getTableListFn = async (current, pageSize, tableHead = {}) => {
    setTableLoading(true);
    const params = {
      page: current || pagination.current,
      count: pageSize || pagination.pageSize,
      ...tableHead,
    };
    const response = await http.get(api.getCheckApproval, { params });
    if (response?.code !== "1") {
      commonFn.modalFailedFn(response);
      setTableLoading(false);
      return;
    }
    const list = (response.data.list || []).map((item, index) => ({
      ...item,
      "#": (params.page - 1) * params.count + index + 1,
    }));
    setTableList(list);
    setPagination((prev) => ({
      ...prev,
      total: response.data.total || 0,
      current: params.page,
      pageSize: params.count,
    }));
    setTableLoading(false);
  };

  const handleTableChange = (pagination, filters, sorter) => {
    getTableListFn(pagination.current, pagination.pageSize, tableHead);
  };

  const handleDetailClick = (record) => {
    const { email, module, batch, moduleType, firstName, dateTimeRequestStr, storeName } =
      record;
    const params = { email, module, batch, storeName };
    console.log("当前记录:", record);
    const route =
      checkApproveRouteDict[module] || checkApproveRouteDict["default"];
    localStorage.setItem(
      "currentMenu",
      `Check Approval - ${moduleType} - Request From "${firstName}" - ${dateTimeRequestStr}`
    );
    const url = `${window.location.origin}#${route}?${new URLSearchParams(
      params
    ).toString()}`;
    window.open(url, "_blank", "noopener,noreferrer");
  };
  const initColunmsFn = () => {
    // setTableHead(initTableHead);
    setColumns(initColumns);
    const transformedList = initColumns.map((item) => ({
      label: item.title,
      value: item.dataIndex,
    }));
    setOptions(transformedList);
    const transformedList2 = initColumns.map((item) => item.dataIndex);
    setSelectedItems(transformedList2);
  };

  const checkApprovalShowDetailFn = async () => {
    const response = await http.get(api.checkApprovalShowDetail);
    if (response?.code === "1") {
      setTotalDetail(response?.data);
    }
  };

  const getDictionaryFn = async (value) => {
    const response = await http.get(api.getDictionary, {
      params: { type: "util_payment", value },
    });
    setModuleList(response);
  };
  // modal  相关
  const approveOrRejectFn = (approvedOrRejected) => {
    if (!selectedList.length) {
      message.warning("Please select at least one item");
      return;
    }
    //  console.log("当前勾选的数据:", selectedList);
    setOpenApproval(true);
    setApprovedOrRejected(approvedOrRejected);
    // 设置表单初始值，包括默认日期
    approvalForm.setFieldsValue({
      transactionCount: "1",
      noLimit: "no",
    });
    // 获取批量拒绝Ids:
    getAllIds()
  };
  const getAllIds = async () => {
    setBtnLoading(true);
    const current = selectedList[0];
    const data = {
      email: current.email,
      batchGroup: current.batch,
      type: current.module,
    };
    const response = await http.post(api.getApproveAllIds, data);
    if (response.code === "1") {
     setIds(response.data.ids);
    } else {
      message.error(`${approvedOrRejected} failed!`);
    }

    setBtnLoading(false);
  };
  const handleSubmit = async () => {
    if (!selectedList.length) {
      message.warning("Please select at least one item");
      return;
    }
  if (!ids || !ids.length) {
    message.error("No ids found, please try again.");
    return;
  }
    setBtnLoading(true);
    const values = await approvalForm.validateFields();
    const current = selectedList[0];
    const data = {
      ...values,
      email: current.email,
      batchGroup: current.batch,
      type: current.module,
      approvedOrRejected,
      ids
    };
    const response = await http.post(api.getApproveAll, data);
    if (response.code === "1") {
      message.success(`${approvedOrRejected} success!`);
      setOpenApproval(false);
      setSelectedList([]);
      getTableListFn(pagination.current, pagination.pageSize, tableHead);
      // 重置表单
      approvalForm.resetFields();
    } else {
      message.error(`${approvedOrRejected} failed!`);
    }
    setBtnLoading(false);
  };

  useEffect(() => {
    const handlePageHide = () => {
      localStorage.setItem("closeBrowserTabFlag", "oldTabClose");
    };

    window.addEventListener("pagehide", handlePageHide);
    return () => window.removeEventListener("pagehide", handlePageHide);
  }, []);

  useEffect(() => {
    const handle = () => {
      if (document.visibilityState === "visible" && localStorage.getItem("closeBrowserTabFlag") === "newTabClose") {
        localStorage.removeItem("closeBrowserTabFlag");
        getTableListFn(pagination.current, pagination.pageSize, tableHead);
        checkApprovalShowDetailFn();
      } else if (document.visibilityState === "visible" && localStorage.getItem("closeBrowserTabFlag") === "oldTabClose") {
        localStorage.removeItem("closeBrowserTabFlag");
      }
    };
    document.addEventListener("visibilitychange", handle);
    handle();
    return () => document.removeEventListener("visibilitychange", handle);
  }, []);

  useEffect(() => {
    getDictionaryFn("type");
  }, []);

  useEffect(() => {
    if (moduleList.length) {
      setColumns(initColumns);
    }
  }, [moduleList]);

  useEffect(() => {
    initColunmsFn();
    getTableListFn(1, 100, tableHead);
    checkApprovalShowDetailFn();
  }, [refreshKey]);

  return (
    <div className="pageMaxWidth">
      <Flex className="topDiv" justify="space-between" align="flex-start">
        <div className="topLeft">
          {/* <div className="total-transactions">
        Total Transactions: {totalDetail}
</div>  */}
          <Button className="btnNew" style={{ marginRight: 0 }}>
            Total Transactions: {totalDetail}
          </Button>
          <Button
            className="btnAgreed"
            style={{ marginRight: 0 }}
            onClick={() => approveOrRejectFn("Approved")}
          >
            <CheckOutlined />
            Approval 
          </Button>

          <Button
            className="btnRefused"
            style={{ marginLeft: 0 }}
            onClick={() => approveOrRejectFn("rejected")}
          >
            <CloseOutlined />
            Reject 
          </Button>
        </div>
        <div className="min-width">
          <Radio.Group defaultValue="a" size="middle">
            <Radio.Button value="a" onClick={() => setRefreshKey(+new Date())}>
              <SyncOutlined />
            </Radio.Button>
            <Radio.Button value="b">
              <Popover content={content} title="" trigger="click">
                <OneToOneOutlined />
                <CaretDownOutlined className="ft12" />
              </Popover>
            </Radio.Button>
            {(commonFn.btnAuthorityFlag("Download") && (
              <Radio.Button value="c">
                <Popover content={content2} title="" trigger="click">
                  <VerticalAlignBottomOutlined />
                  <CaretDownOutlined className="ft12" />
                </Popover>
              </Radio.Button>
            )) ||
              null}
          </Radio.Group>
        </div>
      </Flex>

      <CustomTable
        rowKey="summaryId"
        // refreshKey={refreshKey}
        tableLoading={tableLoading}
        columns={columns}
        tableList={tableList}
        pagination={pagination}
        handleTableChange={handleTableChange}
        tableCss="maintenanceTable"
        rowSelection={{
          preserveSelectedRowKeys: true,
          type: "radio",
          selectedRowKeys: selectedList.map((item) => item.summaryId),
          onChange: (selectedRowKeys, selectedRows) => {
            setSelectedList(selectedRows);
          },
        }}
      />

      <Modal
        title={
          <div style={{ fontSize: "24px", fontWeight: "bold", color: "red" }}>
            <MailOutlined style={{ marginRight: "8px" }} />
            APPROVAL CONFIRMATION
            <div
              style={{ borderTop: "3px solid #3c8dbc", marginTop: "8px" }}
            ></div>
          </div>
        }
        centered
        open={openApproval}
        maskClosable={false}
        onCancel={() => {
          setOpenApproval(false);
          approvalForm.resetFields();
        }}
        onOk={handleSubmit}
        confirmLoading={btnLoading}
        width="30%"
      >
        <Form form={approvalForm} layout="vertical">
          <div style={{ marginBottom: "16px", fontSize: "20px" }}>
            Are you sure you want to approve these checks?
          </div>

          <Form.Item
            name="transactionCount"
            label="How Many Transactions?"
            rules={[{ required: true }]}
            style={{ flex: 1 }}
          >
            <Select
              placeholder="Select option"
              options={[
                {
                  value: "1",
                  label: `${
                    approvedOrRejected === "Approved" ? "Approve" : "Reject"
                  } ${selectedList[0]?.transactions || 0} Check(s).`,
                },
              ]}
            />
          </Form.Item>

          {(approvedOrRejected === "Approved" && (
            <Form.Item
              name="noLimit"
              label={
                <span>
                  Do you want to approve the amount over{" "}
                  {
                    <span
                      style={{ color: "#a94442", textDecoration: "underline" }}
                    >
                      {new Intl.NumberFormat("en-US", {
                        style: "currency",
                        currency: "USD",
                        minimumFractionDigits: 0,
                        maximumFractionDigits: 0,
                      }).format(5000)}
                    </span>
                  }{" "}
                  with signature
                </span>
              }
              style={{ flex: 1 }}
            >
              <Select
                placeholder="Select option"
                options={[
                  {
                    value: "no",
                    label: "No",
                  },
                  {
                    value: "yes",
                    label: "Yes",
                  },
                ]}
              />
            </Form.Item>
          )) ||
            null}

          {(approvedOrRejected !== "Approved" && (
            <Form.Item
              name="rejectedReason"
              label="Rejected Reason"
              style={{ flex: 2 }}
            >
              <Input placeholder="" />
            </Form.Item>
          )) ||
            null}
        </Form>
      </Modal>
    </div>
  );
}
